export default {
  orderchange: {
    searchPlaceholder: '输入商品名或订单编号或供应商进行搜索',
    purchaseNoChg: '订单单号',
    purchaseChgDate: '变更日期',
    supplierNameAfter: '供应商',
    settleOfficeName: '客户',
    purOfficeName: '采购中心',
    employeeNameAfter: '采购人员',
    taxRateMark: '税率',
    taxTypeNameMark: '税种',
    currencyNameMark: '币种',
    txTermsNameMark: '交易条件',
    dataSourceMark: '数据来源',
    outPurchaseNoMark: '外部订单',
    remarksMark: '备注',
    period1: '变更前',
    period2: '变更后',
    goodsName: '品名',
    spec: '规格',
    outPurchaseNo: '外部单号',
    purchaseUnitNo: '采购中心',
    purchaseNo: '项次-项序',
    goodsInfo: '产品信息',
    batchPurMark: '订单量',
    batchValuationMark: '计价数量',
    priceMark: '含税单价',
    batchTaxIncludedAmountMark: '含税金额',
    batchPreTaxAmountMark: '税前金额',
    batchTaxAmountMark: '税额',
    arrivalDateMark: '预计交货日期',
    unreceivedAmount: '外部变更单项次-项序-分批序',
    dataSource: '变更类型',
    chgReason: '变更原因',
    goodsNo: '料号',
    unitNo: '单位',
    valuationUnitNo: '计价单位'
  },
  closingorder: {
    searchPlaceholder: '输入商品或订单编号进行搜索',
    purchaseNo: '订单单号',
    purchaseDate: '订单日期',
    settleOfficeName: '客户',
    purOfficeName: '采购中心  ',
    purchaseUnitNo: '采购中心',
    employeeName: '客户人员',
    remarksHead: '订单备注',
    seqPhase: '项次',
    unitPrice: '含税单价',
    expectedArrivalDate: '交货日期',
    status: '状态码',
    closingReason: '指定结案原因',
    remarks: '订单单身备注',
    dataSource: '数据来源',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    batchPurQty: '订单量'
  },
  ordertrack: {
    searchPlaceholder: '输入商品名或订单编号进行搜索',
    purchaseNo: '订单单号',
    settleOfficeName: '客户',
    queren: '确认量',
    purchaseDate: '订单日期',
    purOfficeName: '采购中心',
    purchaseSeqAndPurchasePhaseSeq: '项次-项序',
    purQty: '在途量',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    batchPurQty: '订单量',
    undeliveredQty: '可发货量',
    unReceiveQty: '未交量',
    shipmentQty: '发货量',
    onWayQty: '在途量',
    expectedArrivalDate: '预计交货日期',
    replyDeliveryNum: '交期回复次数',
    statusName: '状态',
    status: '状态',
    purchaseUnitNo: '采购中心',
    startPurchaseDate: '订单日期-起',
    endPurchaseDate: '订单日期-止',
    startDeliveryDate: '交货日期-起',
    endDeliveryDate: '交货日期-止',
    outPurchaseNo: '外部单号',
    employeeInfo: '采购员',
    orderType: '订单性质',
    orderTypePlaceholder: '请选择订单性质',
    overdueFlag: '仅显示逾期未交订单',
    headInfo: '基础信息',
    addressStr: '地址',
    contacts: '客户联络人',
    contactPhone: '联系方式',
    employeeName: '采购人员',
    remarks: '备注',
    dataSource: '数据来源',
    taxInfo: '交易币种/汇率',
    txTermsName: '交易条件',
    payTermsName: '付款条件',
    totalAmountPreTaxPur: '未税金额',
    totalPurAmount: '税额',
    totalTaxIncludedPur: '含税总金额',
    customerInformation: '客户资料',
    documentInformation: '单据资料',
    paymentInformation: '付款信息',
    purchaseDetail: '订单详情',
    purchaseSeq: '项次',
    purchasePhaseSeq: '项序',
    batchValuationQty: '计价数量',
    unitPrice: '含税单价',
    taxTypeInfo: '税种/税率',
    tableTaxInfo: '未含税/含税/税额',
    receiveQty: '收货量',
    refundQty: '验退量',
    returnExchangeQty: '退换货量',
    orderreply: '分批答交',
    bodyInformation: '单身信息',
    headExpectedArrivalDate: '交货日期',
    tableTitle: '分批明细',
    supReplyQty: '答交数量',
    supReplyDate: '答交日期',
    supReplyRemark: '备注',
    record: '审批记录',
    requiredAdddate: '请选择答交日期',
    requirdSupReplyQty: '答交数量必须输入正整数',
    maxSum: '总答交数量不可超过订单量',
    overTimeTip: '您选择的答交日期超过采购商要求的交货日期,将会提交采购商审批,确认提交吗?',
    overTimeTitle: '信息',
    batchConfirm: '批量确认',
    fileNo: '上传附件',
    notStatus1: '非待确认状态不可操作',
    batchConfirmTip: '是否批量确认？',
    confirmTip: '是否确认？',
    confirm: '确认'
  },
  externalcontrol: {
    applyDate: '申请日期',
    purOfficeNo: '采购中心',
    purchaseNo: '订单单号',
    purchaseSeq: '项次',
    purchasePhaseSeq: '项序',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    applyQty: '申请数量',
    checkedQty: '已申请量',
    checkedOkQty: '检验合格量',
    entry: '外检列表',
    addEntry: '添加项',
    seq: '序号',
    maxApplyQty: '最大申请数量',
    orderQty: '订单量',
    requirdApplyQty: '申请数量需要大于0',
    edit: '编辑',
    remove: '删除',
    check: '审核',
    dilogPlaceholder: '请输入料号/品名/规格查询'
  }
}
